const errorsMapping = {
    CART_IS_EMPTY: 'errors.cartIsEmpty',
    MISSING_CART_ID: 'errors.missingCartID',
    SOMETHING_WENT_WRONG: 'errors.somethingWentWrong',
    CART_NOT_FOUND: 'errors.cartNotFound'
};

export { errorsMapping };
//# sourceMappingURL=error-codes.js.map
